import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class STabs extends UcoastEl {
    static htmlSelector = 's-tabs'
    toggles: NodeListOf<HTMLButtonElement>
    panels: NodeListOf<HTMLElement>
    constructor() {
        super()

        this.toggles = q.rl('.tab__trigger', this)
        this.panels = q.rl('.tab__panel', this)

        this.toggles.forEach(toggle => {
            toggle.addEventListener('click', this.onToggleEvent.bind(this))
        })
    }

    onToggleEvent(e: Event) {
        e.preventDefault()
        const id = q.rClosestTarget(e, 'button').getAttribute('id')
        this.toggles.forEach(toggle => {
            if(toggle.getAttribute('id') === id) {
                toggle.setAttribute('aria-selected', 'true')
                toggle.classList.add('underline-always')
                toggle.classList.remove('underline-on-hover')
            }
            else {
                toggle.setAttribute('aria-selected', 'false')
                toggle.classList.remove('underline-always')
                toggle.classList.add('underline-on-hover')
            }
        })

        this.panels.forEach(panel => {
            if(panel.getAttribute('aria-labelledby') == id) {
                panel.setAttribute('aria-hidden', 'false')
            } else {
                panel.setAttribute('aria-hidden', 'true')
            }
        })
    } 
}
